import { Box, TextField } from "@mui/material";

import { Title, Wrapper } from "./Password.styles";
import FastButton from "../../../../shared/FastButton";

const Password = () => {
  return (
    <Wrapper>
      <Title>Пароль</Title>
      <TextField
        label={"Введите текущий пароль"}
        sx={{
          width: "50%",
          "@media (max-width: 1000px)": {
            width: "100%",
          },
        }}
      />
      <TextField
        label={"Введите новый пароль"}
        sx={{
          width: "50%",
          "@media (max-width: 1000px)": {
            width: "100%",
          },
        }}
      />
      <TextField
        label={"Повторите новый пароль"}
        sx={{
          width: "50%",
          "@media (max-width: 1000px)": {
            width: "100%",
          },
        }}
      />

      <Box
        sx={{
          "@media (max-width: 1000px)": {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
          },
        }}>
        <FastButton variant="contained" title={"Изменить пароль"} />
      </Box>
    </Wrapper>
  );
};
export default Password;
